import React from 'react';
import styled from 'styled-components';
import DefaultLayout from '../layouts/DefaultLayout';
import ecIcon from '../assets/content-icons/indication-icons-hnscc.png';
import helenBig from '../assets/images/helenBig.png';
import vanessaBig from '../assets/images/vanessaBig.png';
import ivIconGreen from '../assets/content-icons/icon-iv-green.png';
import Accordion from '../components/Accordion';
import circleCheck from '../assets/images/circleCheck.png';
import helen from '../assets/images/helen.png';
import vanessa from '../assets/images/vanessa.png';
import TextIcon1Column from '../components/TextIcon1Column';
import { Body, BodyStyle, DesktopOnly, EndoTitle, H3, H4, H6, HeaderH5Style, MobileOnly, Reference, Ul, PreviewTitleStyle, FootnoteStyle, HeaderH6} from '../util/typography';
import hero from '../assets/hero-banners/ec-image-desktop.png';
import PageIntroduction from '../components/PageIntroduction';
import Section from '../components/Section';
import Subsection from '../components/Subsection';
import * as colors from '../util/colors';
import Chart from '../components/Chart';
import mobileChart from '../assets/content-icons/ec-chart-mobile.png';
import desktopChart from '../assets/content-icons/ec-chart-desktop.png';
import desktopBaselineChart from '../assets/content-icons/ec-baseline-desktop.png';
import mobileBaselineChart from '../assets/content-icons/ec-baseline-mobile.png';
import ecWoman from '../assets/content-icons/ec-woman-photo.png';
import Table from '../components/Table';
import PrimaryCallout from '../components/PrimaryCallout';
import mobileEfficacyChart from '../assets/content-icons/ec-efficacy-mobile.png';
import desktopEfficacyChart from '../assets/content-icons/ec-efficacy-desktop.png';
import desktopPfsChart from '../assets/content-icons/ec-pfs-desktop.png';
import mobilePfsChart from '../assets/content-icons/ec-pfs-mobile.png';
import desktopOrrChart from '../assets/content-icons/ec-orr-desktop.png';
import mobileOrrChart from '../assets/content-icons/ec-orr-mobile.png';
import desktopDorChart from '../assets/content-icons/ec-dor-desktop.png';
import mobileDorChart from '../assets/content-icons/ec-dor-mobile.png';
import mobileUaChart from '../assets/content-icons/ec-os-mobile-chart.png';
import desktopUaChart from '../assets/content-icons/ec-os-final-analysis-km-curve-desktop_v06.png';
import mobileComAR from '../assets/content-icons/ec-common-ar-mobile.png';
import { respondTo } from '../util/breakpoints';
import SecondaryCallout from '../components/SecondaryCallout';
import RelatedContent from '../components/RelatedContent';
import { jobCodes } from '../util/data/jobCodes';
import vector from "../assets/utility/icons/vector.svg"
import TextIcon2Column from '../components/TextIcon2Columns';
import reductionrisk from '../assets/content-icons/32risk.png';
import kalpanmobile from '../assets/images/kalpanchart-mob.png';
import kalpandesk from '../assets/images/kalpanchart-desk.png';
import medianTime from '../assets/images/pmmrDesk.png';
import medianTimeMobile from '../assets/images/pmmrMob.png';
import pinchIcon from '../assets/utility/icons/pinch.svg';

const pageMeta = {
    title: `Advanced Endometrial Carcinoma Clinical Trial Results`,
    keywords: `endometrial carcinoma clinical trial results, KEYNOTE-775/Study 309`,
    description: `Health care professionals can review clinical trial results in patients with certain types of advanced endometrial carcinoma.`,
    schemaJsonLD: [
        `{"@context":"https://schema.org/","url":"https://www.keytrudalenvimahcp.com/endometrial-carcinoma/","@type":"ApprovedIndication","name":"KEYTRUDA + LENVIMA","alternateName":"pembrolizumab and lenvatinib","description":"KEYTRUDA, in combination with LENVIMA, is indicated for the treatment of adult patients with advanced endometrial carcinoma that is mismatch repair proficient (pMMR) or not microsatellite instability-high (MSI-H) as determined by an FDA-authorized test, who have disease progression following prior systemic therapy in any setting and are not candidates for curative surgery or radiation."}`,
        `{"@context":"https://schema.org/","url":"https://www.keytrudalenvimahcp.com/endometrial-carcinoma/","@type":"MedicalAudience","audienceType":"Health Care Professionals","geographicArea":"This site is intended for health care professionals of the United States, its territories, and Puerto Rico."}`,
        `{"@context":"https://schema.org/","url":"https://www.keytrudalenvimahcp.com/endometrial-carcinoma/","@type":"MedicalWebPage","name":"Adverse reactions in KEYNOTE-775/Study 309","description":"The safety of KEYTRUDA + LENVIMA was investigated in KEYNOTE-775/Study 309 in patients treated with KEYTRUDA + LENVIMA (n=342) compared to doxorubicin or paclitaxel (n=325) at the protocol-specified interim analysis."}`,
        `{"@context":"https://schema.org/","url":"https://www.keytrudalenvimahcp.com/endometrial-carcinoma/","@type":"MedicalTrial","name":"KEYNOTE-775/Study 309","description":"KEYNOTE-775/Study 309: A pivotal (N=827), multicenter, open-label, randomized, active-controlled, head-to-head phase 3 trial of KEYTRUDA + LENVIMA vs doxorubicin or paclitaxel in patients with advanced endometrial carcinoma. Among the 827 patients, 697 had pMMR (using the VENTANA MMR RxDx Panel test) or not MSI-H tumors","trialDesign":"RandomizedTrial"}`,
        `{"@context":"https://schema.org/","url":"https://www.keytrudalenvimahcp.com/endometrial-carcinoma/","@type":"MedicalGuideline","guideline":"Pembrolizumab (KEYTRUDA) + lenvatinib (LENVIMA) is the ONLY NCCN CATEGORY 1 biomarker-directed therapy recommended by the NCCN Guidelines® for patients with Recurrent or Metastatic Endometrial Carcinoma whose tumors are pMMR, after any one prior platinum-based therapy including neoadjuvant and adjuvant.","recognizingAuthority":"NCCN Clinical Practice Guidelines in Oncology (NCCN Guidelines®)"}`
    ]
}
const PinchContainer = styled.div`
    display: flex;
    gap: 10px;
    color: ${colors.greenDark};
    align-items: center;
`;
const PinchZoomComponent = () => {
    return (
        <MobileOnly>
            <PinchContainer className="pinchContainer">
                <img src={pinchIcon} alt='' />
                <HeaderH6>PINCH TO ZOOM & ENLARGE</HeaderH6>
            </PinchContainer>
        </MobileOnly>
    )
}
const EndoTableWrapper = styled.div`
picture{
border-bottom: none !important;
}
@media (max-width: 768px) {
    picture {
      padding: 15px;
    }
  }
`;
const jobCode = jobCodes[2].jobCode;

const KeytrudaWrapper = styled.div`[class*=__SubsectionContent]::before {
content:none;
}`;

const KeytrudaAccordion = styled(Subsection)`
    gap: 20px;
    p{
        font-size: 16px;
        line-height: 20px;
        font-weight: 400;
    }
    ${respondTo.md`
        padding-top: 30px;
    `}

`;

const OSSection = styled.div`
    display: flex;
    gap: 15px;
    flex-direction: column;
    [class*='__TextIcon2ColumnContent']{
    gap:15px;
    .spacer-10--t{
    margin-top:10px;
    }
        img {
            height: 190px;
            margin: 0 auto;
        }
          ${respondTo.md`
        gap: 30px;
    `}   
    }
    i {
        letter-spacing: 1.2px;
    }
    
       [class*='typography__Ul']
       {
       &.spacer-y-15{
        margin-top:15px;
        margin-bottom:15px;
          ${respondTo.md`
       margin-top:10px;
        margin-bottom:10px;
    `} 
       }
    }
      ${respondTo.md`
    gap: 20px;
        
    `}   
`;

const OSContent = styled.div`
    display: flex;
    gap: 10px;
    flex-direction: column;
    margin-bottom:15px;
    ${respondTo.md`
        margin-bottom:0px;
    `}  
`;


const AccordionTitle = styled(H4)`
`;

const IconNoBullets = styled(TextIcon1Column)`
    align-items: flex-start;


    ${respondTo.md`
        align-items: center;
    `}

`;
const HeroImage = styled.img`
    max-width: 1032px;
    margin: 0 auto;
    display: block;
`;

const PageIntro = styled(PageIntroduction)`
    font-weight: 400;
    padding-bottom: 20px;
    ${respondTo.md`
        padding-bottom: 30px;
    `}
`;

const SectionIntro = styled.div`
    display: flex;
    flex-direction: column;
    gap: 30px;
    .fwbold{
    font-weight:700;}
     &.mingap{
      display: flex;
    gap:15px}
    .spacer-15--b{
        margin-bottom:15px;
        }
    .fw400 {
        font-weight: 400;
    }

    .mob-b-margin{
    margin-bottom:15px;
    }
    i {
        letter-spacing: 1.2px;
    }
  
    ${respondTo.md`
        .mob-b-margin{
    margin-bottom:0;
    }
    `}
`;

const Subtitle = styled.h5`
    ${HeaderH5Style};
    color: ${colors.greenDark};
    line-height: 18px;
`;

const RccFootnote = styled(Reference)`
    display: flex;
    flex-direction: column;
    gap: 5px;
    p {
        width: 100%;
    }
    sup {
        display: flex;
        flex: 0 0 6px;
        justify-content: center;
    }
    
    .footNoteSpace{
        padding-top: 20px;
    }
    .category1{
    display:flex;
    }

`;


const EfficacyTableRow = styled.div`
    display: flex;
    padding: 0;
    > * {
        padding: 20px 5px 20px 10px;
        flex: 1 1 90px;
        &:first-child {
            flex: 0 0 90px;
            font-weight: 700;
        }
    }
    ${respondTo.md`
        &:nth-child(2n + 1){
            background: ${colors.white};
        }
        > * {
            padding: 18px 30px;
            flex: 1 1 342px;
            &:first-child {
                flex: 0 0 342px;
            }
        }
    `}
    &:has([class*='__Reference']){
        background: ${colors.white};
        padding: 20px;
    }
    [class*='__Reference'] {
        flex-basis: 100%;
        padding: 0;
        font-weight: 400;
    }
`;

const DirTableRow = styled(EfficacyTableRow)`
    > * {
        flex: 1 1 114px;
        &:first-child {
            flex: 0 0 114px;
            font-weight: 400;
        }
        ${respondTo.md`
            flex: 1 1 280px;
            &:first-child {
                flex: 0 0 280px;
            }
        `}
    }
    p {
        font-size: 14px;
        ${respondTo.md`
            font-size: 16px;
        `}
    }
    &:has([class*='__Reference']){
        padding: 15px;
        ${respondTo.md`
            padding: 20px;
        `}
    }
    > * {
        &.full-width {
            flex: 1 1 100%;
            text-align: center;
        }
    }
    ${respondTo.md`
        > * {
            &.full-width {
                flex: 1 1 100%;
                font-weight: normal;
                padding: 20px;
            }
        }
    `}
`;

const EfficacyTableColumns = styled.div`
    display: flex;
    gap: 10px;
    width: 100%;
    padding: 15px 5px;
    > * {
        text-align: center;
        flex: 1 0 85px;
    }
    ${respondTo.md`
        padding: 18px 30px;
        > * {
            flex: 1 0 280px;
        }
    `}
`;

const DirTableColumns = styled(EfficacyTableColumns)`
    > * {
        flex: 1 0 73px;
    }
    ${respondTo.md`
        > * {
            flex: 1 0 280px;
        }
    `}
`;


const NoTitleTable = styled(Table)`
    > * {
        text-align: center;
        &:nth-child(2n){
            background: ${colors.white};
        }
        > :first-child {
            flex: 0 0 115px;
            text-align: left;
            padding: 15px 5px 15px 10px;
        }
        ${respondTo.md`
            > :first-child {
                flex: 0 0 342px;
                text-align: left;
                padding: 18px 30px;
            }
        `}
    }
    &.mobile {
        [class*='__Body']{
            margin: auto 0;
        }
    }
`;

const RccTable = styled(Table)`
    h6{
        padding: 20px 10px;
        text-align: center;
        border-bottom: 1px solid ${colors.pebble};
        ${respondTo.md`
            padding: 30px;
        `}
    }
`;

const RccEfficacyIntro = styled.div`
    display: flex;
    flex-direction: column;
    gap: 40px;

    > :first-child {
        margin-bottom: -25px;
    }
    
    h6{
        font-weight: 400;
    }
`;

const RccHypotheticalIntro = styled.div`
    display: flex;
    flex-direction: column;
    gap: 30px;

    h3{
        padding-bottom: 0px;
    }

    h6{
        font-weight: 400;
    }
    ${respondTo.md`
        h3{
            padding-bottom: 10px;
        }
    `}
`;

const ReferenceHypo =  styled.div`
    ${FootnoteStyle};
    margin-top: 10px;
`


const SpecialListContainer = styled.div`
  display: block;
  padding-left: 13px;  
  margin: 15px 0;
  ul {
    list-style-type: none;
    padding: 0;
  }

  ul:first-child {
    margin-bottom: 10px;
  }

  ul li {
    padding-left: 3px;
    margin-bottom: 10px;
    position: relative;

    &:last-child {
      margin-bottom: 0px;
    }

    &::before {
      display: inline-block;
      content: '';
      border-radius: 50%;
      height: 4px;
      width: 4px;
      position: absolute;
      left: -10px;
      top: 8px;
      transform: translateX(-50%);
    }
  }

    ${respondTo.md`
        display: flex;
        justify-content: space-between; 
        padding-left: 13px;
        
        ul {
            width: 100%;
            max-width: 465px;
        }
    `}
`;

const HypotheticalSubTitle = styled.div`
    font-size: 18px;
    font-style: italic;
    font-weight: 400;
    line-height: 22px;
    padding-bottom: 10px;
    text-align: center;
    &.customtitle{
text-align:left;
font-weight:700;
padding-left:0px;
font-style:normal;
    }

    ${respondTo.md`
        padding: 0 40px 0;     
    `}
`;


const HorizontalLine = styled.div`
    background: #BEBEBE;
    width: 100%;
    height: 1px;
`;

const HypoHorizontalLine = styled.div`
    background: #BEBEBE;
    width: 100%;
    height: 1px;
    margin: 20px 0px;
`;

const HypoOutHorizontalLine = styled.div`
    background: #BEBEBE;
    width: 100%;
    height: 1px;
`;
 
const DivFlex = styled.div`
    display: block;
    padding-top: 15px;

    > div{
        gap: 10px;
        margin-bottom: 25px;

        img{
            margin-left: 0;
        }
    }
    > div:last-child{
        margin-bottom: 0px;
    }
    
    ${respondTo.md`
        display: flex;
        align-items: start;
        column-gap: 30px;
        padding-top: 30px;

        > div{
            gap: 15px;
            margin-bottom: 0px;

            img{
                margin-left: 0;
            }
        }

        > div:last-child{
            margin-bottom: 0px;
        }
        
    `}
`;


const CommonARColumn = styled.div`
    padding: 15px 30px;
    gap: 10px;
    display: flex;
    width: 100%;
    > * {
        flex: 1 0 50%;
        text-align: center;
    }
`;

const AnchorNavLinks = [
    
        {
            title: 'On this page: ',
        },
        {
            title: <>Study Design and <br className='display-desktop'/>Baseline Characteristics</>,
            href: '#study-design',
            icon: vector,
        },
        {
            title: <>Hypothetical <br className='display-desktop'/> Patients</>,
            href: '#hypothetical',
            icon: vector,
        },
        {
            title: 'Efficacy',
            href: '#efficacy',
            icon: vector,
        },
        {
            title: <>Adverse <br className='display-desktop'/>Reactions</>,
            href:'#adverse-reaction',
            icon: vector,
        },
         {
            title: <>NCCN <br className='display-desktop'/>Recommendation</>,
             href: '#nccn-recommendation',
            icon: vector,
        }
    ];
    
    

const EndoTable = styled(Table)`
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    border: 1px solid ${({type}) => type === 'keytruda' ? colors.brandGreen : type === 'lenvima' ? colors.mulberry : colors.lightGrey};
    h6{
        text-align: center;
    }
      
    > *:first-child {
        padding: 20px 10px;
        background: ${colors.white};
        border-bottom: 1px solid ${({type}) => type === 'keytruda' ? colors.brandGreen : type === 'lenvima' ? colors.mulberry : colors.lightGrey};
        color: ${({type}) => type === 'keytruda' ? colors.greenDark : type === 'lenvima' ? colors.mulberry : colors.charcoal};
        ${respondTo.md`
             padding: 30px;
        `}
     }

    [class*='__ShadedTableRow'] {
        background: ${colors.white};
    }

    [class*='__ShadedTableColumn'] > * {
        border-bottom: 1px solid ${colors.mist};
    }
    
    [class*='__ShadedTableColumn']:nth-child(1) > :nth-child(2n){
        background: ${colors.white};
    }

    [class*='__ShadedTableColumn']:nth-child(3) > :nth-child(${({noOfCells}) => noOfCells === 'odd' ? '2n + 1' : '2n'}){
        background: ${colors.white};
    }

    ${respondTo.md`
        [class*='__ShadedTableColumn']:nth-child(1) > :nth-child(2n){
            background: ${colors.white};
        }
        [class*='__ShadedTableColumn']:nth-child(3) > :nth-child(2n){
            background: ${colors.white};
        }
    `}

`;

const ShadedTableRow = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0;
    .divider  {
        display: none;
    }
    > :nth-child(3){
        > :last-child {
            border-radius: 0 0 8px 8px;
        }
    }
    .last-element-hidden{
        border-radius: 0 0 8px 8px;
        border-bottom: 0;
    }
    .bottomBorder{
        border-bottom: 1px solid ${colors.mist};
    }
    > * {
        &.full-width {
            flex: 1 1 100%;
            font-weight: normal;
            padding: 18px 30px;
            text-align: center;
        }
    }
    ${respondTo.md`
        flex-direction: row;
        .divider  {
            display: block;
            background: white;
            width: 10px;
            height: 100%;
            border: 1px solid white;
            min-height: 55px;
        }
        > :nth-child(1){
            > :last-child {
                border-radius: 0 0 0px 8px;
            }
        }
        > :nth-child(3){
            > :last-child {
                border-radius: 0 0 8px 0px;
            }
        }
        .last-element-hidden{
            border-radius: 0;
            border-bottom: 1px solid ${colors.mist};
        }
    `}
`;

const ShadedTableColumn = styled.div`
    width: 100%;
    p {
        padding-top: 18px;
        padding-bottom: 18px;
        padding-left: 30px;
        padding-right: 30px;
    }
    ${respondTo.md`
        width: 50%; 
    `}
`;

const SingleTableColumn = styled.div`
    width: 100%;

    p:nth-child(1){
        padding-bottom: 10px;
    }

    sup{
        top: -0.6em;
    }

    ${respondTo.md`
        p:nth-child(1){
            padding-bottom: 0px;
            width: 100%;
            max-width: 240px;
        }
    `}
`;

const SingleTableDivs = styled.div`
    display: block;
    align-items: flex-start;
    gap: 10px;
    border-bottom: 1px solid #C4C4C4;
    padding: 20px 5px 20px 10px;

    ${respondTo.md`
        display: flex;
        align-items: center;
        gap: 20px;
        padding-top: 18px;
        padding-bottom: 18px;
        padding-left: 30px;
        padding-right: 30px;
    `}
`;

const GreenTableHeader = styled(H6)`
    color: ${colors.greenDark};
`;

const MulberryTableHeader = styled(H6)`
    color: ${colors.mulberry};
`;

const ShadedTableSingle = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    ${BodyStyle};
    padding: 15px 10px;
    text-align: center;
    ${respondTo.md`
        padding: 18px 30px;
    `}
`;

const EndoLayout = styled(DefaultLayout)`
    [class*='__PageHeaderTitle']{
        ${EndoTitle};
        @media(max-width:767px){
            font-size: 22px;
            font-weight: 400;
            line-height: 24px;
            text-transform: none;
            font-style: normal;
        }
    }

    .display-desktop{
        @media (max-width: 767px) {
         display: none !important;
        }
    }
    
`;


const RCCHypotheticalLast = styled.div`
    p {
        font-size: unset;
        line-height: unset;
    }
`;

const RCCEfficacyCallout = styled(PrimaryCallout)`
    [class*='PrimaryCallout__Title-']{
        font-weight: 400;
    }
    &:before {
        border-left: 5px solid ${colors.mulberry};
        background: linear-gradient(96deg, ${colors.brandGreen} 47.42%, ${colors.greenGradient} 100%);
    }
    &.noBorder {
        padding-left: 20px;
        ${respondTo.md`
            padding-left: 0px;
        `}
    }
    &.noBorder:before {
        content: none;
    }
`;

const BaselineCallout = styled(RCCEfficacyCallout)`
    padding: 40px 20px 0 40px;
    height: 288px;
    max-width: 100%;
    position: relative;
    .callout-row {
        display: flex;
        flex-direction: column;
        gap: 20px;
        width: 220px;
        margin: 0 auto;
        justify-content: space-between;
        align-items: center;
        [class*='__Body-']{
            line-height: 0;
        }
        img{
            width: 158px;
            height: 140px;
        }
        ${respondTo.md`
            flex-direction: row;
            padding: 0 0px 0 60px;
            gap: 40px;
            height: 140px;
            width: unset;
        `}
    }
    [class*='__Reference-']{
        position: absolute;
        bottom: -10px;
        transform: translateY(100%);
        right: 0;
    }
    ${respondTo.md`
        padding: 0 0px 0 60px;
        height: 140px;
    `}
`;

const OrrChart = styled(Chart)`
    [class*='__ChartTitle']{
        width: 100%;
    }
    ${respondTo.md`
        &.orr {
            img {
                width: 100%;
                margin: 0 auto;
                display: block;
            }
        }
    `}
`;

const UpdateAnalysisBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

const IndicationFootNote = styled.div`
    padding-top: 20px;
    padding-bottom: 30px;
`;

const CommonARTableRow = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0;
    border: none;
    > * :not(.divider) {
        border-bottom: 1px solid ${colors.mist};
    }
    .borderBottomNone {
        border-bottom: 0px;
    }
    > * {
        flex: 1 0 320px;
        display: flex;
        justify-content: center;
        align-items: center;
        &:first-child {
            flex: 0 0 310px;
        }
        &:first-child {
            justify-content: start;
            padding-left: 30px;
        }
    }
    &:last-child p{
        border-radius: 0 0 8px 8px;
    }
    &:has([class*='__Reference']){
        background: ${colors.white};
        padding: 20px;
    }
    [class*='__Reference'] {
        flex-basis: 100%;
        align-items: start;
        ${respondTo.md`
            padding: 0;
        `}
    }
    ${respondTo.md`
        flex-direction: row;        
        .divider  {
            display: block;
            background: white;
            width: 10px;
            border: 1px solid white;
            min-height: 55px;
            flex: unset;
        }
    `}
`;

const CommonARTitle = styled.div`
    display: flex;
    flex-direction: column;
    padding: 20px 0px 0px 0px;
`;

const FDASection = styled(Section)`
    padding-bottom: 0;
    [class*='__SubsectionContent-']{
        padding-top: 0;
    }
    h6 {
        font-weight: 400;
    }
`;

const PdChart = styled(Chart)`
    [class*='__MobileOnly-']{
        display: flex;
        img{
            border-radius: 0 0 6px 6px;
            padding-top: 18px;
        }
    }

    [class*='__ChartTitle']{
        padding: 20px 10px;
    }

    [class*='__ChartChildren']{
        padding: 0;
    }
    [class*='__Reference']{
        padding: 0 15px 15px 15px;
    }
`;

const NccnCallout = styled(SecondaryCallout)`
    ${PreviewTitleStyle};
    margin: 0 10px 10px 0;
    text-align: center;
    [class*='SecondaryCallout__Title-']{
        font-weight: 400;
    }
`;

const NccnSection = styled(Section)`
 
    [class*='__RccFootnote']{
        div {
            p {
                position: relative;
                margin-left: 4px;
                line-height: 1.5;
                display: inline-block; 
                
            }
            .start {
                position: absolute;
                left: -4px; 
                top: -5px;
                vertical-align: super;
            }
            .end {
                    display: inline;
                    vertical-align: super;
                    white-space: nowrap;
                    top: -0.1em !important;
                }
            .endNew {
                    display: inline;
                    // vertical-align: super;
                    // white-space: nowrap;
                    // top: -0.1em !important;
                }
            
        }
    }
`;

const RccReference = styled(Subsection)`
    padding: 40px 20px 0 20px;
    word-break: break-word;
    ${respondTo.md`
        padding: 20px 30px 0 30px;
    `}
`;

const StudyDesignSection = styled(Section)`
    padding-bottom: 64px;
`;

const HypotheticalDesignSection = styled(Section)`
    padding-bottom: 64px;
`;

const IndicationPageInto = styled(PageIntro)`
    gap: 0;
`;

const IndicationParagraph = styled(H4)`
    padding-bottom: 40px;
`;
const IndicationH3 = styled(H3)`
  font-size: 24px;
   line-height: 26px;
   @media (max-width: 767px) {
    font-size: 22px;
    line-height: 24px;
  }
`;

const RCLinks = [
    {
        eyebrow: 'Safety',
        title: 'Monitor and help manage adverse reactions',
        to: '/treatment-management-and-dose-modifications'
    },
    {
        eyebrow: 'Dosing',
        title: 'Learn more about dosing and administration',
        to: '/dosing'
    },
];


const Endo = ({location}) => {
    return (
        <EndoLayout location={ location } name='KEYNOTE-775/Study 309 in Advanced Endometrial Carcinoma: Efficacy and Safety Results' icon={ecIcon} anchorNavLinks={AnchorNavLinks} pageMeta={pageMeta} jobCode={jobCode} hyptheticNav="present">
            <DesktopOnly>
                <HeroImage src={hero} alt='Focus on Possibilities for Treating Your Patients With Certain Types of Advanced Endometrial Carcinoma' />
            </DesktopOnly>
            <IndicationPageInto>
                <IndicationH3><b>Indication</b></IndicationH3>
                <IndicationParagraph as="p">KEYTRUDA, in combination with LENVIMA, is indicated for the treatment of adult patients with advanced endometrial carcinoma that is mismatch repair proficient (pMMR) or not microsatellite instability-high (MSI-H) as determined by an FDA-authorized test, who have disease progression following prior systemic therapy in any setting and are not candidates for curative surgery or radiation.</IndicationParagraph>
                <RCCEfficacyCallout bg='mist' cursor={false}>
                    <div>
                        <b>The FIRST AND ONLY anti–PD-1 + TKI combination approved for adult patients with certain types of advanced endometrial carcinoma.<sup>1–9</sup></b>
                    </div>
                </RCCEfficacyCallout>
                <RccFootnote>
                    <IndicationFootNote as="p">PD-1 = programmed death receptor-1; TKI = tyrosine kinase inhibitor.</IndicationFootNote>
                </RccFootnote>      
                <H3 as="H2"><b>KEYNOTE-775/Study 309:</b> Pivotal phase 3 data that may help inform your approach to treating patients with certain types of advanced endometrial carcinoma</H3>    
            </IndicationPageInto>
            <StudyDesignSection title='Study Design and BASELINE Characteristics' bgColor='cloud' id='study-design'>
                <SectionIntro>
                    <Subtitle>FOCUS ON STUDY DESIGN</Subtitle>
                    <H4><b>KEYNOTE-775/Study 309:</b> A pivotal (N=827), multicenter, open-label, randomized, active-controlled, head-to-head phase 3 trial of <b><keytitle>KEYTRUDA</keytitle> + <lentitle>LENVIMA</lentitle></b> vs <b>doxorubicin or paclitaxel</b> in patients with advanced endometrial carcinoma. Among the 827 patients, 697 had pMMR (using the VENTANA MMR RxDx Panel test) or not MSI-H tumors</H4>
                </SectionIntro>
                <Subsection>
                    <Chart imgSrc={mobileChart} desktopImgSrc={desktopChart} noTitle showNote imgAlt='Study Design for KEYNOTE-775/Study 309: Key Inclusion/Exclusion Criteria, Stratification Factors, and Major and Additional Endpoints'>
                    </Chart>
                    <RccFootnote>
                        <p><sup>a</sup>Treatment was permitted beyond RECIST v1.1–defined disease progression if the treating investigator considered the patient to be deriving clinical benefit and the treatment was tolerated.</p>
                        <p><sup>b</sup>According to RECIST v1.1, modified to follow a maximum of 10 target lesions and a maximum of 5 target lesions per organ.</p>
                        <p>ECOG PS = Eastern Cooperative Oncology Group performance status; IV = intravenous; RECIST v1.1 = Response Evaluation Criteria In Solid Tumors v1.1; BICR = blinded independent central review.</p>
                    </RccFootnote>
                </Subsection>
                <Subsection>
                    <Subtitle>FOCUS ON BASELINE CHARACTERISTICS</Subtitle>
                    <Chart imgSrc={mobileBaselineChart} desktopImgSrc={desktopBaselineChart} showNote imgAlt='697 Patients With Certain Types of Advanced Endometrial Carcinoma Were Enrolled in KEYNOTE-775/Study 309 Trial: Baseline Characteristics Including Age, Race, ECOG PS, Histology, and Prior Systemic Therapies'>
                        <H6>KEYNOTE-775/Study 309 enrolled patients with advanced endometrial carcinoma that was pMMR or not MSI-H across histological subtypes and systemic treatment histories (N=697)</H6>
                    </Chart>
                    <BaselineCallout cursor={false}>
                        <div class='callout-row'>
                            <div>
                                <b>37% of patients</b><MobileOnly><br/></MobileOnly> received only prior neoadjuvant or adjuvant therapy.
                            </div>
                            <img src={ecWoman} alt=''/>
                        </div>
                        <Reference>Hypothetical Patient</Reference>
                    </BaselineCallout>
                </Subsection>
                


            </StudyDesignSection>

            <Section title='HYPOTHETICAL PATIENTS' id='hypothetical' bgColor=''>
                <RccHypotheticalIntro>
                    <H3 as="H2">Consider <b><keytitle>KEYTRUDA</keytitle> + <lentitle>LENVIMA</lentitle></b> for your adult patients with certain types of advanced endometrial carcinoma that is pMMR or not MSI-H <br/></H3>
                    <SectionIntro>    
                        <H6>KEYTRUDA, in combination with LENVIMA, is indicated for the treatment of adult patients with advanced endometrial carcinoma that is pMMR or not MSI-H as determined by an FDA-authorized test, who have disease progression following prior systemic therapy in any setting and are not candidates for curative surgery or radiation.</H6>                    
                        
                        <div>
                            <H4>In KEYNOTE-775/Study 309, patients with advanced endometrial carcinoma received prior systemic therapy in the following settings:</H4>
                            <SpecialListContainer>
                                <Ul marker={colors.charcoal}>
                                    <li>Neoadjuvant Only</li>
                                    <li>Adjuvant Only</li>
                                </Ul>
                                <Ul marker={colors.charcoal}>
                                    <li>Neoadjuvant and Adjuvant</li>
                                    <li>Advanced</li>
                                </Ul>
                            </SpecialListContainer>
                            <p>Patients experienced tumor recurrence/disease progression following prior systemic therapy, with no option for curative surgery or radiation.</p>
                        </div>
                        
                        <div>
                        <H4><b>Eligibility criteria for use of <keytitle>KEYTRUDA</keytitle> + <lentitle>LENVIMA</lentitle></b> (all criteria must be met)</H4>

                        <DivFlex>
                            <TextIcon1Column imgSrc={circleCheck} imgAlt=''>
                                <p><b>Advanced endometrial carcinoma that is pMMR or not MSI-H as determined by an FDA-authorized test</b></p>
                            </TextIcon1Column>

                            <TextIcon1Column imgSrc={circleCheck} imgAlt=''>
                                <p><b>Disease progression following prior systemic therapy in any setting,</b> including in the neoadjuvant and adjuvant settings</p>
                            </TextIcon1Column>

                            <TextIcon1Column imgSrc={circleCheck} imgAlt=''>
                                <p><b>Not a candidate for curative surgery or radiation</b></p>
                            </TextIcon1Column>
                        </DivFlex>
                        </div>
                    </SectionIntro>
                    <HypoOutHorizontalLine>&nbsp;</HypoOutHorizontalLine>
                </RccHypotheticalIntro>

                <KeytrudaAccordion>
                    <AccordionTitle>View profiles of hypothetical patients who may be eligible for <keytitle><b>KEYTRUDA</b></keytitle> <b>+</b> <lentitle><b>LENVIMA</b></lentitle></AccordionTitle>
                    <Accordion  warningMsg={false} title='Helen, 62' type='keytruda' descriptionAcc='Disease progression 11 months after receiving platinum-based regimen' desImg={helen}>
                        <div>
                            <TextIcon1Column imgSrc={helenBig} imgAlt='' effHypoPatientStyle>
                                <H6><b>Helen, 62</b></H6>
                                <Ul>
                                    <li>Advanced endometrial carcinoma that is pMMR or not MSI-H</li>
                                    <li>ECOG PS: 1; Comorbidity: Obesity (BMI = 30 kg/m<sup>2</sup>)</li>
                                    <li>Disease progression 11 months after receiving platinum-based regimen</li>
                                </Ul>
                                <HypoHorizontalLine>&nbsp;</HypoHorizontalLine>
                                <HypotheticalSubTitle>“When I got the news that my cancer spread, I was devastated. But I want to stay focused on my next steps.”</HypotheticalSubTitle>
                            </TextIcon1Column>                        
                        </div>
                        
                       <EndoTable type='default' noOfCells='even'>
                            <H6>Diagnosis and Treatment History</H6>
                            <ShadedTableRow>
                                <SingleTableColumn>
                                    <SingleTableDivs>
                                    <Body><b>Initial diagnosis:</b></Body>
                                    <Body>Stage II endometrial carcinoma with grade 2 endometrioid histology</Body>
                                    </SingleTableDivs>

                                    <SingleTableDivs>
                                    <Body><b>Biomarker status:</b></Body>
                                    <Body>pMMR or not MSI-H,<sup>a</sup> determined at diagnosis</Body>
                                    </SingleTableDivs>

                                    <SingleTableDivs>
                                    <Body><b>Surgery and radiation:</b></Body>
                                    <Body>Total abdominal hysterectomy with bilateral salpingo-oophorectomy with lymph node assessment, followed by EBRT</Body>
                                    </SingleTableDivs>

                                    <SingleTableDivs>
                                    <Body><b>Disease recurrence:</b></Body>
                                    <Body>At 18-month follow-up, PET/CT scan of the chest, abdomen, and pelvis revealed a tumor mass with invasion into the bladder and no evidence of lymph node involvement or distant metastases</Body>
                                    </SingleTableDivs>

                                    <SingleTableDivs>
                                    <Body><b>First systemic therapy:</b></Body>
                                    <Body>Platinum-based regimen</Body>
                                    </SingleTableDivs>

                                    <SingleTableDivs>
                                    <Body><b>Disease progression:</b></Body>
                                    <Body>11 months after completing 6 cycles of chemotherapy, CT revealed disease progression (liver metastases) with no option for curative surgery or radiation</Body>
                                    </SingleTableDivs>
                                </SingleTableColumn>
                            </ShadedTableRow>
                        </EndoTable>
                        <RCCHypotheticalLast>
                            <RCCEfficacyCallout  bg='mist' cursor={false}>
                                <div>
                                    How might <b><keytitle>KEYTRUDA</keytitle> + <lentitle>LENVIMA</lentitle> fit into your treatment plan</b> for Helen?
                                </div>
                            </RCCEfficacyCallout>
                            <RccFootnote>
                                <p className='footNoteSpace'><sup>a</sup>Determined by an FDA-authorized test.</p>
                                <p>BMI = body mass index; EBRT = external beam radiation therapy; PET = positron emission tomography; CT = computed tomography.</p>                            
                            </RccFootnote>
                        </RCCHypotheticalLast>
                    </Accordion>

                    <Accordion  warningMsg={false} title='Vanessa, 69' type='keytruda' descriptionAcc='Disease recurrence 10 months after receiving adjuvant treatment' desImg={vanessa}>
                        <div>
                            <TextIcon1Column imgSrc={vanessaBig} imgAlt='' effHypoPatientStyle>
                                <H6><b>Vanessa, 69</b></H6>
                                <Ul>
                                    <li>Advanced endometrial carcinoma that is pMMR or not MSI-H</li>
                                    <li>ECOG PS: 1; Comorbidity: Type 2 diabetes</li>
                                    <li>Disease recurrence 10 months after receiving adjuvant treatment</li>
                                </Ul>
                                <HypoHorizontalLine>&nbsp;</HypoHorizontalLine>
                                <HypotheticalSubTitle>“After surgery, radiation, and chemotherapy, my cancer returned. I'm still committed to finding out from my doctor what treatment options are available to me.”</HypotheticalSubTitle>
                            </TextIcon1Column>                        
                        </div>


                        <EndoTable type='default' noOfCells='even'>
                            <H6>Diagnosis and Treatment History</H6>
                            <ShadedTableRow>
                                <SingleTableColumn>
                                    <SingleTableDivs>
                                    <Body><b>Initial diagnosis:</b></Body>
                                    <Body>Stage IIIC1 endometrial carcinoma with grade 3 endometrioid histology</Body>
                                    </SingleTableDivs>

                                    <SingleTableDivs>
                                    <Body><b>Biomarker status:</b></Body>
                                    <Body>pMMR or not MSI-H<sup>a</sup></Body>
                                    </SingleTableDivs>

                                    <SingleTableDivs>
                                    <Body><b>Surgery:</b></Body>
                                    <Body>Total abdominal hysterectomy with bilateral salpingo-oophorectomy and pelvic lymph node dissection</Body>
                                    </SingleTableDivs>

                                    <SingleTableDivs>
                                    <Body><b>First systemic therapy and radiation:</b></Body>
                                    <Body>Adjuvant treatment with carboplatin/paclitaxel and EBRT</Body>
                                    </SingleTableDivs>

                                    <SingleTableDivs>
                                    <Body><b>Disease recurrence:</b></Body>
                                    <Body>10 months after completing 6 cycles of chemotherapy, CT revealed her cancer had metastasized to her lungs, with no option for curative surgery or radiation</Body>
                                    </SingleTableDivs>                                    
                                </SingleTableColumn>
                            </ShadedTableRow>
                        </EndoTable>
                        <RCCHypotheticalLast>
                            <RCCEfficacyCallout  bg='mist' cursor={false}>
                                <div>
                                    Patients like Vanessa may be candidates for <b><keytitle>KEYTRUDA</keytitle> + <lentitle>LENVIMA</lentitle></b>.
                                </div>
                            </RCCEfficacyCallout>
                            <RccFootnote>
                                <p className='footNoteSpace'><sup>a</sup>Determined by an FDA-authorized test.</p>
                                <p>EBRT = external beam radiation therapy; CT = computed tomography.</p>                            
                            </RccFootnote>
                        </RCCHypotheticalLast>
                    </Accordion>

                    <Reference>Hypothetical Patients</Reference>
                </KeytrudaAccordion>
            </Section>

            <Section title='EFFICACY' id='efficacy' bgColor='cloud'>
              
                <RccEfficacyIntro>
                    <H6>At the protocol-specified interim analysis in KEYNOTE-775/Study 309 (phase 3 trial) for certain patients with advanced endometrial carcinoma that is pMMR or not MSI-H:</H6>
                    <H3><b>Proven superiority across OS, PFS, and ORR</b> vs <b>doxorubicin or paclitaxel alone</b>: <b><keytitle>KEYTRUDA</keytitle> + <lentitle>LENVIMA</lentitle></b> is an anti–PD-1 + TKI combination for adult patients with certain types of advanced endometrial carcinoma that is pMMR or not MSI-H</H3>
                    <SectionIntro>
                        <Subtitle className="fwbold">FOCUS ON OVERALL SURVIVAL</Subtitle>
                        <H4><b>Proven superior OS</b> with <b><keytitle>KEYTRUDA</keytitle> + <lentitle>LENVIMA</lentitle></b> vs <b>doxorubicin or paclitaxel alone</b> at <b>protocol-specified interim analysis</b></H4>
                      
                  
                
                 
               
                     <OSSection>
                  <TextIcon2Column>
                                        <img src={reductionrisk} alt='32% Reduced Risk of Death' className='img' />
                                        <div>
                
                                            <Ul marker={colors.charcoal}>
                                                <li><b>HR<sup>c</sup>=0.68 (95% CI, 0.56–0.84); <i>P</i><sup>d</sup>=0.0001.</b></li>
                                                <li>Events observed: 165/346 (48%) with KEYTRUDA + LENVIMA vs 203/351 (58%) with doxorubicin or paclitaxel.</li>
                                                <li><b>Median OS: 17.4 months</b> (95% CI, 14.2–19.9) with KEYTRUDA + LENVIMA vs <b>12.0 months</b> (95% CI, 10.8–13.3) with doxorubicin or paclitaxel.</li>
                                                <li>OS was a major endpoint with PFS in KEYNOTE-775/Study 309.</li>
                                            </Ul>
                
                                        </div>
                                    </TextIcon2Column>
                                    <RccFootnote>
                                        <p><sup>c</sup>Based on the stratified Cox regression model.</p>
                                        <p><sup>d</sup>Based on stratified log-rank test.</p>
                                        <p>OS = overall survival; PFS = progression-free survival; ORR = objective response rate; HR = hazard ratio; CI = confidence interval.</p>
                                    </RccFootnote>
                                   
                                </OSSection>
                                
                    {/* <Chart imgSrc={mobileEfficacyChart} desktopImgSrc={desktopEfficacyChart} showNote imgAlt='KEYNOTE-775/Study 309 Trial: OS at Protocol Specified Interim Analysis With KEYTRUDA® (pembrolizumab) + LENVIMA® (lenvatinib) vs doxorubicin or paclitaxel Alone'>
                        <H6>Kaplan-Meier estimates for OS with <keytitle>KEYTRUDA</keytitle> + <lentitle>LENVIMA</lentitle> (n=346) vs doxorubicin or paclitaxel (n=351) in the KEYNOTE-775/Study 309 trial (pMMR or not MSI-H)</H6>
                        <RccFootnote>
                            <p><sup>c</sup>Based on the stratified Cox regression model.</p>
                            <p><sup>d</sup>Based on stratified log-rank test.</p>
                        </RccFootnote>
                    </Chart> */}
                    <RCCEfficacyCallout cursor={false}>
                        <div>
                            Patients lived a <b>median of 5.4 months longer</b> with <b><keytitle>KEYTRUDA</keytitle> + <lentitle>LENVIMA</lentitle></b> vs <b>doxorubicin or paclitaxel</b> (17.4 vs 12.0 months, respectively).
                        </div>
                    </RCCEfficacyCallout>
                      </SectionIntro>
                                </RccEfficacyIntro>
                        <Subsection>
                                        <SectionIntro className='mingap'>
                                          
                                            <H6 className='fw400'>In KEYNOTE-775/Study 309</H6>
                                            <H4><b>Post hoc exploratory analysis: 5-year OS in the pMMR or not MSI-H population<sup>10,11</sup></b></H4>
                                            <UpdateAnalysisBody>
                                                <Body><b>LIMITATION: This post hoc analysis (median follow-up time: 68.8 months) was exploratory in nature and occurred after the protocol-specified final analysis. There was no formal statistical testing planned for this analysis. No conclusions can be drawn.</b>
                                                </Body>
                                                <Ul marker={colors.charcoal}><li>In the chemotherapy arm, 11.7% (41/351) of patients in the pMMR population received subsequent treatment with KEYTRUDA + LENVIMA.</li></Ul>
                                            </UpdateAnalysisBody>
                                          
                                            {/* <Subtitle>UPDATED ANALYSIS</Subtitle> */}
                                          
                                        </SectionIntro>
                                        <OrrChart imgSrc={kalpanmobile} desktopImgSrc={kalpandesk} showNote imgAlt='Kaplan-Meier Estimates for Post hoc Exploratory Analysis: 5-year OS in the pMMR or not MSI-H Population in KEYNOTE-775/Study 309 Trial'>
                                            <H6>Kaplan-Meier estimates for OS in KEYNOTE-775/Study 309 (pMMR or not MSI-H)</H6>
                        <RccFootnote>
                            <p>Adapted by permission from BMJ Publishing Group Limited. Lenvatinib plus pembrolizumab in previously treated advanced endometrial cancer: 5‑year outcomes from the randomized, phase 3 Study 309/KEYNOTE‑775; Makker V, Colombo N, Casado A, et al.<em style={{display: "contents"}}> J Immunother Cancer</em>. 2026;14:e013713. Copyright © 2026.</p>
                        </RccFootnote>
                                        </OrrChart>
                                        <Ul marker={colors.charcoal}>
                                            <li>Events observed: 285/346 (82.4%) with KEYTRUDA + LENVIMA vs 310/351 (88.3%) with doxorubicin or paclitaxel.</li>
                                            <li><b>Median OS: 18.0 months</b> (95% CI, 14.9–20.5) with KEYTRUDA + LENVIMA vs <b>12.2 months</b> (95% CI, 11.0–14.1) with doxorubicin or paclitaxel alone.</li>
                                            <li><b>Median follow-up time was 68.8 months</b> (data cutoff date: February 26, 2025).</li>
                                        </Ul>
                                  
                </Subsection>
                <Subsection>
                                            <div>
                                                <TextIcon1Column>
                                                    <Body className='mb-5'>In KEYNOTE-775/Study 309</Body>
                                                    <H4><b>Post hoc exploratory analysis: 5-year OS by subgroup in the pMMR or not MSI-H population<sup>12</sup></b></H4>
                                                    <p><b>LIMITATION: The 5-year follow-up exploratory analysis of KEYNOTE-775/Study 309 was not powered to detect differences in the treatment effect for these subgroups. Results from exploratory subgroup analyses should be interpreted with caution and no conclusions can be drawn.</b></p>
                    
                    
                                                </TextIcon1Column>
                                                <HypoHorizontalLine>&nbsp;</HypoHorizontalLine>
                                                <HypotheticalSubTitle className='customtitle'><p><b>Overall survival in subgroups at 5 years was generally consistent with the subgroups in the interim analysis.<sup>11,13</sup></b></p></HypotheticalSubTitle>
                    
                                            </div>
                                            <PinchZoomComponent />
                                            <EndoTableWrapper>
                                                <EndoTable type='default' noOfCells='even'>
                                                    <H6>5-year OS by subgroups (pMMR or not MSI-H)</H6>
                                                    <picture>
                                                        <source srcSet={medianTimeMobile} media='(max-width: 768px)' />
                                                        <source srcSet={medianTime} media='(min-width: 769px)' />
                                                        <img style={{ width: "100%" }} src={medianTime} alt='Kaplan-Meier Estimates for Post hoc Exploratory Analysis: 5-year OS by Subgroup in the pMMR or not MSI-H Population in KEYNOTE-775/Study 309 Trial' />
                                                    </picture>
                                                    <RCCHypotheticalLast>
                    
                                                        <RccFootnote>
                                                            <p className='footNoteSpace'>Data cutoff date: February 26, 2025. </p>
                                                            <p><sup>e</sup>Includes participants who received prior neo/adjuvant chemotherapy only.</p>
                    
                                                        </RccFootnote>
                                                    </RCCHypotheticalLast>
                                                </EndoTable>
                                            </EndoTableWrapper>
                </Subsection>
                
                <Subsection>
                    <SectionIntro>
                        <Subtitle>FOCUS ON PROGRESSION-FREE SURVIVAL</Subtitle>
                        <H4><b>Proven superior PFS<sup>f</sup></b> with <b><keytitle>KEYTRUDA</keytitle> + <lentitle>LENVIMA</lentitle></b> vs <b>doxorubicin or paclitaxel alone</b> at <b>protocol-specified interim analysis</b></H4>
                        <Ul marker={colors.charcoal}>
                            <li><b>HR<sup>c</sup>=0.60 (95% CI, 0.50–0.72); <i>P</i><sup>d</sup>&lt;0.0001.</b></li>
                            <li>Events observed: 247/346 (71%) with KEYTRUDA + LENVIMA vs 238/351 (68%) with doxorubicin or paclitaxel.</li>
                            <li><b>Median PFS: 6.6 months</b> (95% CI, 5.6–7.4) with KEYTRUDA + LENVIMA vs <b>3.8 months</b> (95% CI, 3.6–5.0) with doxorubicin or paclitaxel.</li>
                            <li>PFS was a major endpoint with OS in KEYNOTE-775/Study 309.</li>
                        </Ul>
                    </SectionIntro>
                    <Chart imgSrc={mobilePfsChart} desktopImgSrc={desktopPfsChart} showNote imgAlt='KEYNOTE-775/Study 309 Trial: PFS at Protocol Specified Interim Analysis With KEYTRUDA® (pembrolizumab) + LENVIMA® (lenvatinib) vs doxorubicin or paclitaxel Alone'>
                        <H6>Kaplan-Meier estimates for PFS<sup>f</sup> with <keytitle>KEYTRUDA</keytitle> + <lentitle>LENVIMA</lentitle> (n=346) vs doxorubicin or paclitaxel (n=351) in the KEYNOTE-775/Study 309 trial (pMMR or not MSI-H)</H6>
                        <RccFootnote>
                            <p><sup>c</sup>Based on the stratified Cox regression model.</p>
                            <p><sup>d</sup>Based on the stratified log-rank test.</p>
                            <p><sup>f</sup>Per independent radiology review.</p>
                        </RccFootnote>
                    </Chart>
                    <RCCEfficacyCallout bg='white' cursor={false}>
                        <div>
                            Patients lived with <b>more disease progression–free time</b> with <b><keytitle>KEYTRUDA</keytitle> + <lentitle>LENVIMA</lentitle></b> vs <b>doxorubicin or paclitaxel</b> <b>(HR<sup>c</sup>=0.60 [95% CI, 0.50–0.72]; <em>P</em><sup>d</sup>&lt;0.0001). <keytitle>KEYTRUDA</keytitle> + <lentitle>LENVIMA</lentitle></b> achieved 6.6 months of median PFS vs 3.8 months with <b>doxorubicin or paclitaxel</b>.
                        </div>
                    </RCCEfficacyCallout>
                </Subsection>
                <Subsection>
                    <SectionIntro>
                        <Subtitle>FOCUS ON OBJECTIVE RESPONSE RATE</Subtitle>
                        <H4><b>Proven superior ORR<sup>f,g</sup>:</b> Patients were 2x as likely to respond with <b><keytitle>KEYTRUDA</keytitle> + <lentitle>LENVIMA</lentitle></b> (30%) vs <b>doxorubicin or paclitaxel alone</b> (15%) at <b>protocol-specified interim analysis</b></H4>
                    </SectionIntro>
                    <OrrChart imgSrc={mobileOrrChart} desktopImgSrc={desktopOrrChart} showNote className='orr' imgAlt='The Objective Response Rates With KEYTRUDA® (pembrolizumab) and LENVIMA® (lenvatinib) (n=346) vs doxorubicin or paclitaxel (n=351) Alone'>
                        <H6>ORR (additional endpoint): pMMR or not MSI-H</H6>
                        <RccFootnote>
                            <p><sup>f</sup>Per independent radiology review.</p>
                            <p><sup>g</sup>Response: Best objective response as confirmed CR or PR.</p>
                            <p><sup>h</sup>Based on Miettinen and Nurminen method stratified by ECOG PS, geographic region, and history of pelvic radiation.</p>
                            <p>CR = complete response;&nbsp;PR = partial response.</p>
                        </RccFootnote>
                    </OrrChart>
                    <RCCEfficacyCallout cursor={false}>
                        <div>
                            <b>Doubled ORR</b> with <b><keytitle>KEYTRUDA</keytitle> + <lentitle>LENVIMA</lentitle></b> vs <b>doxorubicin or paclitaxel</b>.
                        </div>
                    </RCCEfficacyCallout>
                </Subsection>
                <Subsection>
                    <SectionIntro>
                        <Subtitle>DURATION OF RESPONSE</Subtitle>
                        <H4><b>Longer median DOR</b> observed with <b><keytitle>KEYTRUDA</keytitle> + <lentitle>LENVIMA</lentitle></b> vs <b>doxorubicin or paclitaxel alone</b> at <b>protocol-specified interim analysis</b></H4>
                    </SectionIntro>
                    <OrrChart imgSrc={mobileDorChart} desktopImgSrc={desktopDorChart} showNote imgAlt='Median Duration of Response Observed With KEYTRUDA® (pembrolizumab) + LENVIMA® (lenvatinib) (n=105) vs doxorubicin or paclitaxel (n=53) Alone'>
                        <H6>DOR (additional endpoint): pMMR or not MSI-H</H6>
                        <RccFootnote>
                            DOR = duration of response.
                        </RccFootnote>
                    </OrrChart>
                </Subsection>
               
            </Section>
            <Section bgColor='white' title='Adverse Reactions' id='adverse-reaction'>
                <SectionIntro>
                    <H3><b>Adverse reactions</b> in KEYNOTE-775/Study 309</H3>
                    <Body>The safety of KEYTRUDA + LENVIMA was investigated in KEYNOTE-775/Study 309 in patients treated with KEYTRUDA + LENVIMA (n=342) compared to doxorubicin or paclitaxel (n=325) at the protocol-specified interim analysis.</Body>
                    <Ul marker={colors.charcoal}>
                        <li>Median duration of study treatment was 7.2 months (range: 1 day–26.8 months).</li>
                    </Ul>
                </SectionIntro>
                <Subsection>
                    <DesktopOnly>
                        <NoTitleTable type='default'>
                            <EfficacyTableRow>
                                <Body></Body>
                                <EfficacyTableColumns>
                                    <Body><keytitle><b>KEYTRUDA</b></keytitle></Body>
                                    <Body><lentitle><b>LENVIMA</b></lentitle></Body>
                                </EfficacyTableColumns>
                            </EfficacyTableRow>
                            <EfficacyTableRow>
                                <Body><b>Median duration of exposure (months)</b></Body>
                                <EfficacyTableColumns>
                                    <Body>6.8 (range: 1 day–25.8 months)</Body>
                                    <Body>6.7 (range: 1 day–26.8 months)</Body>
                                </EfficacyTableColumns>
                            </EfficacyTableRow>
                        </NoTitleTable>
                    </DesktopOnly>
                    <MobileOnly>
                        <NoTitleTable type='default' className='mobile'>
                            <EfficacyTableRow>
                                <Body></Body>
                                <EfficacyTableColumns>
                                    <Body><b>Median duration of exposure (months)</b></Body>
                                </EfficacyTableColumns>
                            </EfficacyTableRow>
                            <EfficacyTableRow>
                                <Body><keytitle><b>KEYTRUDA</b></keytitle></Body>
                                <EfficacyTableColumns>
                                    <Body>6.8 (range: 1 day–25.8 months)</Body>
                                </EfficacyTableColumns>
                            </EfficacyTableRow>
                            <EfficacyTableRow>
                                <Body><lentitle><b>LENVIMA</b></lentitle></Body>
                                <EfficacyTableColumns>
                                    <Body>6.7 (range: 1 day–26.8 months)</Body>
                                </EfficacyTableColumns>
                            </EfficacyTableRow>
                        </NoTitleTable>
                    </MobileOnly>
                </Subsection>
                <Subsection>
                    <SectionIntro>
                        <Subtitle>FOCUS ON FATAL AND SERIOUS ADVERSE REACTIONS</Subtitle>
                    </SectionIntro>
                    <EndoTable type='default' noOfCells='even'>
                        <H6>Fatal adverse reactions occurred in 4.7% of patients treated with <keytitle>KEYTRUDA</keytitle> + <lentitle>LENVIMA</lentitle>, including 2 cases of pneumonia, and 1 case of the following:</H6>
                        <ShadedTableRow>
                            <ShadedTableColumn>
                                <Body>Acute kidney injury</Body>
                                <Body>Acute myocardial infarction</Body>
                                <Body>Colitis</Body>
                                <Body>Decreased appetite</Body>
                                <Body>Intestinal perforation</Body>
                                <Body>Lower gastrointestinal hemorrhage</Body>
                            </ShadedTableColumn>
                            <div className='divider'/>
                                <ShadedTableColumn>
                                <Body>Malignant gastrointestinal obstruction</Body>
                                <Body>Multiple organ dysfunction syndrome</Body>
                                <Body>Myelodysplastic syndrome</Body>
                                <Body>Pulmonary embolism</Body>
                                <Body className='last-element-hidden'>Right ventricular dysfunction</Body>
                                <DesktopOnly><Body></Body></DesktopOnly>
                            </ShadedTableColumn>
                        </ShadedTableRow>
                    </EndoTable>
                    <RCCEfficacyCallout className='noBorder' bg="mist" cursor={false}>
                        <div>
                            <b>Serious adverse reactions occurred in 50% of patients receiving <b><keytitle>KEYTRUDA</keytitle> + <lentitle>LENVIMA</lentitle></b>.</b>
                        </div>
                    </RCCEfficacyCallout>
                    <EndoTable type='default' noOfCells='odd'>
                        <H6>Serious adverse reactions (≥3%) in patients receiving <keytitle>KEYTRUDA</keytitle> + <lentitle>LENVIMA</lentitle> were: </H6>
                        <ShadedTableRow>
                            <ShadedTableColumn>
                                <Body>Hypertension (4.4%)</Body>
                            </ShadedTableColumn>
                            <div className='divider'/>
                            <ShadedTableColumn>
                                <Body>Urinary tract infection (3.2%)</Body>
                            </ShadedTableColumn>
                        </ShadedTableRow>
                    </EndoTable>
                </Subsection>
                <Subsection>
                    <SectionIntro>
                        <Subtitle>FOCUS ON DISCONTINUATION, INTERRUPTION, AND DOSE REDUCTION</Subtitle>
                    </SectionIntro>
                    <RccTable type='default'>
                        <H6>Discontinuation and interruption rates for <keytitle><b>KEYTRUDA</b></keytitle> and for <lentitle><b>LENVIMA</b></lentitle>, and dose reduction rate for <lentitle><b>LENVIMA</b></lentitle> due to adverse reactions in KEYNOTE-775/Study 309</H6>
                        <DirTableRow>
                            <Body></Body>
                            <DirTableColumns>
                                <Body><keytitle><b>KEYTRUDA</b></keytitle></Body>
                                <Body><lentitle><b>LENVIMA</b></lentitle></Body>
                            </DirTableColumns>
                        </DirTableRow>
                        <DirTableRow>
                            <Body>Discontinuation</Body>
                            <DirTableColumns>
                                <Body>15%</Body>
                                <Body>26%</Body>
                            </DirTableColumns>
                        </DirTableRow>
                        <DirTableRow>
                            <Body>Dose reduction</Body>
                            <DirTableColumns>
                                <Body>N/A</Body>
                                <Body>67%</Body>
                            </DirTableColumns>
                        </DirTableRow>
                        <DirTableRow>
                            <Body>Dose interruption</Body>
                            <DirTableColumns>
                                <Body>48%</Body>
                                <Body>58%</Body>
                            </DirTableColumns>
                        </DirTableRow>
                        <DirTableRow>
                            <Body className='full-width'>
                                No dose reduction for <keytitle><b>KEYTRUDA</b></keytitle> is recommended.
                            </Body>
                        </DirTableRow>
                        <DirTableRow>
                            <Reference>N/A = not applicable.</Reference>
                        </DirTableRow>
                    </RccTable>
                    <EndoTable type='keytruda'>
                        <GreenTableHeader>The most common (≥1%) adverse reaction leading to discontinuation of KEYTRUDA was:</GreenTableHeader>
                        <ShadedTableSingle>
                            Increased alanine aminotransferase (1.2%)
                        </ShadedTableSingle>
                    </EndoTable>
                    <EndoTable type='lenvima' noOfCells='odd'>
                        <MulberryTableHeader>The most common (≥1%) adverse reactions leading to discontinuation of LENVIMA were:</MulberryTableHeader>
                        <ShadedTableRow>
                            <ShadedTableColumn>
                                <Body>Hypertension (2%)</Body>
                                <Body>Asthenia (1.8%)</Body>
                                <Body>Diarrhea (1.2%)</Body>
                            </ShadedTableColumn>
                            <div className='divider'/>
                            <ShadedTableColumn>
                                <Body>Decreased appetite (1.2%)</Body>
                                <Body>Proteinuria (1.2%)</Body>
                                <Body>Vomiting (1.2%)</Body>
                            </ShadedTableColumn>
                        </ShadedTableRow>
                    </EndoTable>
                    <EndoTable type='keytruda'>
                        <GreenTableHeader>The most common (≥3%) adverse reactions leading to interruption of KEYTRUDA were:</GreenTableHeader>
                        <ShadedTableRow>
                            <ShadedTableColumn>
                                <Body>Diarrhea (8%)</Body>
                                <Body>Increased alanine aminotransferase (4.4%)</Body>
                            </ShadedTableColumn>
                            <div className='divider'/>
                            <ShadedTableColumn>
                                <Body>Increased aspartate aminotransferase (3.8%)</Body>
                                <Body>Hypertension (3.5%)</Body>
                            </ShadedTableColumn>
                        </ShadedTableRow>
                    </EndoTable>
                    <EndoTable type='lenvima' noOfCells='odd'>
                        <MulberryTableHeader>The most common (≥2%) adverse reactions leading to interruption of LENVIMA were:</MulberryTableHeader>
                        <ShadedTableRow>
                            <ShadedTableColumn>
                                <Body>Hypertension (11%)</Body>
                                <Body>Diarrhea (11%)</Body>
                                <Body>Proteinuria (6%)</Body>
                                <Body>Decreased appetite (5%)</Body>
                                <Body>Vomiting (5%)</Body>
                                <Body>Increased alanine aminotransferase (3.5%)</Body>
                                <Body>Fatigue (3.5%)</Body>
                            </ShadedTableColumn>
                            <div className='divider'/>
                            <ShadedTableColumn>
                                <Body>Nausea (3.5%)</Body>
                                <Body>Abdominal pain (2.9%)</Body>
                                <Body>Weight decreased (2.6%)</Body>
                                <Body>Urinary tract infection (2.6%)</Body>
                                <Body>Increased aspartate aminotransferase (2.3%)</Body>
                                <Body>Asthenia (2.3%)</Body>
                                <Body>Palmar-plantar erythrodysesthesia (2%)</Body>
                            </ShadedTableColumn>
                        </ShadedTableRow>
                    </EndoTable>
                    <EndoTable type='lenvima' noOfCells='even'>
                        <MulberryTableHeader>The most common (≥5%) adverse reactions resulting in dose reduction of LENVIMA were:</MulberryTableHeader>
                        <ShadedTableRow>
                            <ShadedTableColumn>
                                <Body>Hypertension (18%)</Body>
                                <Body>Diarrhea (11%)</Body>
                                <Body>Palmar-plantar erythrodysesthesia syndrome (9%)</Body>
                                <Body>Proteinuria (7%)</Body>
                            </ShadedTableColumn>
                            <div className='divider'/>
                            <ShadedTableColumn>
                                <Body>Fatigue (7%)</Body>
                                <Body>Decreased appetite (6%)</Body>
                                <Body>Asthenia (5%)</Body>
                                <Body>Weight decreased (5%)</Body>
                            </ShadedTableColumn>
                        </ShadedTableRow>
                        <ShadedTableRow>
                            <Body className='full-width'>No dose reduction for <b><keytitle>KEYTRUDA</keytitle></b> is recommended.</Body>
                        </ShadedTableRow>
                    </EndoTable>
                </Subsection>
                <Subsection>
                    <SectionIntro>
                        <Subtitle>FOCUS ON MOST COMMON ADVERSE REACTIONS</Subtitle>
                    </SectionIntro>
                    <DesktopOnly>
                        <EndoTable type='default'>
                            <H6>Adverse reactions occurring in ≥20% of patients receiving <keytitle>KEYTRUDA</keytitle> + <lentitle>LENVIMA</lentitle> in KEYNOTE-775/Study 309</H6>
                            <CommonARTableRow>
                                <Body><b>Adverse Reaction</b></Body>
                                <div className='divider'/>
                                <CommonARTitle>
                                    <Body><b><keytitle>KEYTRUDA</keytitle> + <lentitle>LENVIMA</lentitle> (n=342)</b></Body>
                                    <CommonARColumn>
                                        <Body><b>All Grades<sup>i</sup> (%)</b></Body>
                                        <Body><b>Grade 3–4 (%)</b></Body>
                                    </CommonARColumn>
                                </CommonARTitle>
                                <div className='divider'/>
                                <CommonARTitle>
                                    <Body><b>Doxorubicin or Paclitaxel (n=325)</b></Body>
                                    <CommonARColumn>
                                        <Body><b>All Grades<sup>i</sup> (%)</b></Body>
                                        <Body><b>Grade 3–4 (%)</b></Body>
                                    </CommonARColumn>
                                </CommonARTitle>
                            </CommonARTableRow>
                            <CommonARTableRow>
                                <Body>Hypothyroidism<sup>j</sup></Body>
                                <div className='divider'/>
                                <CommonARColumn>
                                    <Body>67</Body>
                                    <Body>0.9</Body>
                                </CommonARColumn>
                                <div className='divider'/>
                                <CommonARColumn>
                                    <Body>0.9</Body>
                                    <Body>0</Body>
                                </CommonARColumn>
                            </CommonARTableRow>
                            <CommonARTableRow>
                                <Body>Hypertension<sup>k</sup></Body>
                                <div className='divider'/>
                                <CommonARColumn>
                                    <Body>67</Body>
                                    <Body>39</Body>
                                </CommonARColumn>
                                <div className='divider'/>
                                <CommonARColumn>
                                    <Body>6</Body>
                                    <Body>2.5</Body>
                                </CommonARColumn>
                            </CommonARTableRow>
                            <CommonARTableRow>
                                <Body>Fatigue<sup>l</sup></Body>
                                <div className='divider'/>
                                <CommonARColumn>
                                    <Body>58</Body>
                                    <Body>11</Body>
                                </CommonARColumn>
                                <div className='divider'/>
                                <CommonARColumn>
                                    <Body>54</Body>
                                    <Body>6</Body>
                                </CommonARColumn>
                            </CommonARTableRow>
                            <CommonARTableRow>
                                <Body>Diarrhea<sup>m</sup></Body>
                                <div className='divider'/>
                                <CommonARColumn>
                                    <Body>55</Body>
                                    <Body>8</Body>
                                </CommonARColumn>
                                <div className='divider'/>
                                <CommonARColumn>
                                    <Body>20</Body>
                                    <Body>2.8</Body>
                                </CommonARColumn>
                            </CommonARTableRow>
                            <CommonARTableRow>
                                <Body>Musculoskeletal disorders<sup>n</sup></Body>
                                <div className='divider'/>
                                <CommonARColumn>
                                    <Body>53</Body>
                                    <Body>5</Body>
                                </CommonARColumn>
                                <div className='divider'/>
                                <CommonARColumn>
                                    <Body>27</Body>
                                    <Body>0.6</Body>
                                </CommonARColumn>
                            </CommonARTableRow>
                            <CommonARTableRow>
                                <Body>Nausea</Body>
                                <div className='divider'/>
                                <CommonARColumn>
                                    <Body>49</Body>
                                    <Body>2.9</Body>
                                </CommonARColumn>
                                <div className='divider'/>
                                <CommonARColumn>
                                    <Body>47</Body>
                                    <Body>1.5</Body>
                                </CommonARColumn>
                            </CommonARTableRow>
                            <CommonARTableRow>
                                <Body>Decreased appetite<sup>o</sup></Body>
                                <div className='divider'/>
                                <CommonARColumn>
                                    <Body>44</Body>
                                    <Body>7</Body>
                                </CommonARColumn>
                                <div className='divider'/>
                                <CommonARColumn>
                                    <Body>21</Body>
                                    <Body>0</Body>
                                </CommonARColumn>
                            </CommonARTableRow>
                            <CommonARTableRow>
                                <Body>Vomiting</Body>
                                <div className='divider'/>
                                <CommonARColumn>
                                    <Body>37</Body>
                                    <Body>2.3</Body>
                                </CommonARColumn>
                                <div className='divider'/>
                                <CommonARColumn>
                                    <Body>21</Body>
                                    <Body>2.2</Body>
                                </CommonARColumn>
                            </CommonARTableRow>
                            <CommonARTableRow>
                                <Body>Stomatitis<sup>p</sup></Body>
                                <div className='divider'/>
                                <CommonARColumn>
                                    <Body>35</Body>
                                    <Body>2.6</Body>
                                </CommonARColumn>
                                <div className='divider'/>
                                <CommonARColumn>
                                    <Body>26</Body>
                                    <Body>1.2</Body>
                                </CommonARColumn>
                            </CommonARTableRow>
                            <CommonARTableRow>
                                <Body>Abdominal pain<sup>q</sup></Body>
                                <div className='divider'/>
                                <CommonARColumn>
                                    <Body>34</Body>
                                    <Body>2.6</Body>
                                </CommonARColumn>
                                <div className='divider'/>
                                <CommonARColumn>
                                    <Body>21</Body>
                                    <Body>1.2</Body>
                                </CommonARColumn>
                            </CommonARTableRow>
                            <CommonARTableRow>
                                <Body>Weight loss</Body>
                                <div className='divider'/>
                                <CommonARColumn>
                                    <Body>34</Body>
                                    <Body>10</Body>
                                </CommonARColumn>
                                <div className='divider'/>
                                <CommonARColumn>
                                    <Body>6</Body>
                                    <Body>0.3</Body>
                                </CommonARColumn>
                            </CommonARTableRow>
                            <CommonARTableRow>
                                <Body>Urinary tract infection<sup>r</sup></Body>
                                <div className='divider'/>
                                <CommonARColumn>
                                    <Body>31</Body>
                                    <Body>5</Body>
                                </CommonARColumn>
                                <div className='divider'/>
                                <CommonARColumn>
                                    <Body>13</Body>
                                    <Body>1.2</Body>
                                </CommonARColumn>
                            </CommonARTableRow>
                            <CommonARTableRow>
                                <Body>Proteinuria<sup>s</sup></Body>
                                <div className='divider'/>
                                <CommonARColumn>
                                    <Body>29</Body>
                                    <Body>6</Body>
                                </CommonARColumn>
                                <div className='divider'/>
                                <CommonARColumn>
                                    <Body>3.4</Body>
                                    <Body>0.3</Body>
                                </CommonARColumn>
                            </CommonARTableRow>
                            <CommonARTableRow>
                                <Body>Constipation</Body>
                                <div className='divider'/>
                                <CommonARColumn>
                                    <Body>27</Body>
                                    <Body>0</Body>
                                </CommonARColumn>
                                <div className='divider'/>
                                <CommonARColumn>
                                    <Body>25</Body>
                                    <Body>0.6</Body>
                                </CommonARColumn>
                            </CommonARTableRow>
                            <CommonARTableRow>
                                <Body>Headache</Body>
                                <div className='divider'/>
                                <CommonARColumn>
                                    <Body>26</Body>
                                    <Body>0.6</Body>
                                </CommonARColumn>
                                <div className='divider'/>
                                <CommonARColumn>
                                    <Body>9</Body>
                                    <Body>0.3</Body>
                                </CommonARColumn>
                            </CommonARTableRow>
                            <CommonARTableRow>
                                <Body>Hemorrhagic events<sup>t</sup></Body>
                                <div className='divider'/>
                                <CommonARColumn>
                                    <Body>25</Body>
                                    <Body>2.6</Body>
                                </CommonARColumn>
                                <div className='divider'/>
                                <CommonARColumn>
                                    <Body>15</Body>
                                    <Body>0.9</Body>
                                </CommonARColumn>
                            </CommonARTableRow>
                            <CommonARTableRow>
                                <Body>Palmar-plantar erythrodysesthesia<sup>u</sup></Body>
                                <div className='divider'/>
                                <CommonARColumn>
                                    <Body>23</Body>
                                    <Body>2.9</Body>
                                </CommonARColumn>
                                <div className='divider'/>
                                <CommonARColumn>
                                    <Body>0.9</Body>
                                    <Body>0</Body>
                                </CommonARColumn>
                            </CommonARTableRow>
                            <CommonARTableRow>
                                <Body>Dysphonia</Body>
                                <div className='divider'/>
                                <CommonARColumn>
                                    <Body>22</Body>
                                    <Body>0</Body>
                                </CommonARColumn>
                                <div className='divider'/>
                                <CommonARColumn>
                                    <Body>0.6</Body>
                                    <Body>0</Body>
                                </CommonARColumn>
                            </CommonARTableRow>
                            <CommonARTableRow>
                                <Body>Rash<sup>v</sup></Body>
                                <div className='divider'/>
                                <CommonARColumn>
                                    <Body>20</Body>
                                    <Body>2.3</Body>
                                </CommonARColumn>
                                <div className='divider'/>
                                <CommonARColumn>
                                    <Body>4.9</Body>
                                    <Body>0</Body>
                                </CommonARColumn>
                            </CommonARTableRow>
                            <CommonARTableRow>
                                <RccFootnote className='borderBottomNone'>
                                    <p><sup>i</sup>Graded per NCI-CTCAE v4.03.</p>
                                    <p><sup>j</sup>Includes hypothyroidism, blood thyroid stimulating hormone increased, thyroiditis, primary hypothyroidism, secondary hypothyroidism.</p>
                                    <p><sup>k</sup>Includes hypertension, blood pressure increased, hypertensive crisis, secondary hypertension, blood pressure abnormal, hypertensive encephalopathy, blood pressure fluctuation.</p>
                                    <p><sup>l</sup>Includes fatigue, asthenia, malaise, lethargy.</p>
                                    <p><sup>m</sup>Includes diarrhea, gastroenteritis.</p>
                                    <p><sup>n</sup>Includes arthralgia, myalgia, back pain, pain in extremity, bone pain, neck pain, musculoskeletal pain, arthritis, musculoskeletal chest pain, musculoskeletal stiffness, non-cardiac chest pain, pain in jaw.</p>
                                    <p><sup>o</sup>Includes decreased appetite, early satiety.</p>
                                    <p><sup>p</sup>Includes stomatitis, mucosal inflammation, oropharyngeal pain, aphthous ulcer, mouth ulceration, cheilitis, oral mucosal erythema, tongue ulceration.</p>
                                    <p><sup>q</sup>Includes abdominal pain, abdominal pain upper, abdominal pain lower, abdominal discomfort, gastrointestinal pain, abdominal tenderness, epigastric discomfort.</p>
                                    <p><sup>r</sup>Includes urinary tract infection, cystitis, pyelonephritis.</p>
                                    <p><sup>s</sup>Includes proteinuria, protein urine present, hemoglobinuria.</p>
                                    <p><sup>t</sup>Includes epistaxis, vaginal hemorrhage, hematuria, gingival bleeding, metrorrhagia, rectal hemorrhage, contusion, hematochezia, cerebral hemorrhage, conjunctival hemorrhage, gastrointestinal hemorrhage, hemoptysis, hemorrhage urinary tract, lower gastrointestinal hemorrhage, mouth hemorrhage, petechiae, uterine hemorrhage, anal hemorrhage, blood blister, eye hemorrhage, hematoma, hemorrhage intracranial, hemorrhagic stroke, injection site hemorrhage, melena, purpura, stoma site hemorrhage, upper gastrointestinal hemorrhage, wound hemorrhage, blood urine present, coital bleeding, ecchymosis, hematemesis, hemorrhage subcutaneous, hepatic hematoma, injection site bruising, intestinal hemorrhage, laryngeal hemorrhage, pulmonary hemorrhage, subdural hematoma, umbilical hemorrhage, vessel puncture site bruise.</p>
                                    <p><sup>u</sup>Includes palmar-plantar erythrodysesthesia syndrome, palmar erythema, plantar erythema, skin reaction.</p>
                                    <p><sup>v</sup>Includes rash, rash maculo-papular, rash pruritic, rash erythematous, rash macular, rash pustular, rash papular, rash vesicular, application site rash.</p>
                                    <p>NCI-CTCAE = National Cancer Institute-Common Terminology Criteria for Adverse Events.</p>
                                </RccFootnote>
                            </CommonARTableRow>
                        </EndoTable>
                    </DesktopOnly>
                    <MobileOnly>
                        <PdChart imgSrc={mobileComAR} showNote imgAlt='Adverse Reactions That Occurred in ≥20% of Patients Receiving KEYTRUDA® (pembrolizumab) and LENVIMA® (lenvatinib) in the KEYNOTE‑775/Study 309 Trial'>
                            <H6>Adverse reactions occurring in ≥20% of patients receiving <keytitle>KEYTRUDA</keytitle> + <lentitle>LENVIMA</lentitle> in KEYNOTE-775/Study 309</H6>
                            <RccFootnote>
                                    <p><sup>i</sup>Graded per NCI-CTCAE v4.03.</p>
                                    <p><sup>j</sup>Includes hypothyroidism, blood thyroid stimulating hormone increased, thyroiditis, primary hypothyroidism, secondary hypothyroidism.</p>
                                    <p><sup>k</sup>Includes hypertension, blood pressure increased, hypertensive crisis, secondary hypertension, blood pressure abnormal, hypertensive encephalopathy, blood pressure fluctuation.</p>
                                    <p><sup>l</sup>Includes fatigue, asthenia, malaise, lethargy.</p>
                                    <p><sup>m</sup>Includes diarrhea, gastroenteritis.</p>
                                    <p><sup>n</sup>Includes arthralgia, myalgia, back pain, pain in extremity, bone pain, neck pain, musculoskeletal pain, arthritis, musculoskeletal chest pain, musculoskeletal stiffness, non-cardiac chest pain, pain in jaw.</p>
                                    <p><sup>o</sup>Includes decreased appetite, early satiety.</p>
                                    <p><sup>p</sup>Includes stomatitis, mucosal inflammation, oropharyngeal pain, aphthous ulcer, mouth ulceration, cheilitis, oral mucosal erythema, tongue ulceration.</p>
                                    <p><sup>q</sup>Includes abdominal pain, abdominal pain upper, abdominal pain lower, abdominal discomfort, gastrointestinal pain, abdominal tenderness, epigastric discomfort.</p>
                                    <p><sup>r</sup>Includes urinary tract infection, cystitis, pyelonephritis.</p>
                                    <p><sup>s</sup>Includes proteinuria, protein urine present, hemoglobinuria.</p>
                                    <p><sup>t</sup>Includes epistaxis, vaginal hemorrhage, hematuria, gingival bleeding, metrorrhagia, rectal hemorrhage, contusion, hematochezia, cerebral hemorrhage, conjunctival hemorrhage, gastrointestinal hemorrhage, hemoptysis, hemorrhage urinary tract, lower gastrointestinal hemorrhage, mouth hemorrhage, petechiae, uterine hemorrhage, anal hemorrhage, blood blister, eye hemorrhage, hematoma, hemorrhage intracranial, hemorrhagic stroke, injection site hemorrhage, melena, purpura, stoma site hemorrhage, upper gastrointestinal hemorrhage, wound hemorrhage, blood urine present, coital bleeding, ecchymosis, hematemesis, hemorrhage subcutaneous, hepatic hematoma, injection site bruising, intestinal hemorrhage, laryngeal hemorrhage, pulmonary hemorrhage, subdural hematoma, umbilical hemorrhage, vessel puncture site bruise.</p>
                                    <p><sup>u</sup>Includes palmar-plantar erythrodysesthesia syndrome, palmar erythema, plantar erythema, skin reaction.</p>
                                    <p><sup>v</sup>Includes rash, rash maculo-papular, rash pruritic, rash erythematous, rash macular, rash pustular, rash papular, rash vesicular, application site rash.</p>
                                    <p>NCI-CTCAE = National Cancer Institute-Common Terminology Criteria for Adverse Events.</p>
                                </RccFootnote>
                        </PdChart>
                    </MobileOnly>
                </Subsection>
            </Section>
            <FDASection bgColor="cloud">
                <SectionIntro>
                    <H6><b>FDA-APPROVED INDICATION</b><br/>KEYTRUDA, in combination with LENVIMA, is indicated for the treatment of adult patients with advanced endometrial carcinoma that is mismatch repair proficient (pMMR) or not microsatellite instability-high (MSI-H) as determined by an FDA-authorized test, who have disease progression following prior systemic therapy in any setting and are not candidates for curative surgery or radiation.</H6>
                </SectionIntro>
                <Subsection></Subsection>
            </FDASection>
            <NccnSection title='NCCN RECOMMENDATION' id='nccn-recommendation' bgColor="cloud">
                <SectionIntro>
                <div className='mob-b-margin'>
                <H6 className='newNccn'><b>NCCN Clinical Practice Guidelines in Oncology (NCCN Guidelines®) recommendation for certain types of advanced endometrial carcinoma<sup>14</sup></b></H6>
                </div>
                    <NccnCallout noIcon bgColor="white">
                    <p><b>Pembrolizumab (<keytitle>KEYTRUDA</keytitle>)</b> + <b>lenvatinib (<lentitle>LENVIMA</lentitle>)</b> is the <b>ONLY NCCN CATEGORY 1</b> biomarker-directed therapy recommended by the NCCN Guidelines® for patients with <b>Recurrent or Metastatic Endometrial Carcinoma</b> whose tumors are <b>pMMR,</b> after any one prior platinum-based therapy including neoadjuvant and adjuvant.<sup>14,w</sup></p>
                    </NccnCallout>
                </SectionIntro>
                <Subsection>
                    <RccFootnote>
                        <p>NCCN makes no warranties of any kind whatsoever regarding their content, use, or application and disclaims any responsibility for their application or use in any way.</p>
                        <div><p style={{lineHeight:'14px'}}><sup className="start">w</sup>Category 1 = Based upon high-level evidence (≥1 randomized phase 3 trials or high-quality, robust meta-analyses), there is uniform NCCN consensus (≥85% support of the Panel) that the intervention is appropriate.<sup className="endNew">14</sup></p></div>
                        <p>NCCN = National Comprehensive Cancer Network® (NCCN®).</p>
                    </RccFootnote>
                </Subsection>
            </NccnSection>
            <RelatedContent title='Learn more about adverse reaction management and dosing' links={RCLinks}/>
            <Section noIntro>
                <RccReference>
                    <Reference>
                        <b>References: 1.</b> Opdivo. Prescribing information. Bristol-Myers Squibb Company; 2026. <b>2.</b> Zynyz. Prescribing information. Incyte Corporation; 2026. <b>3.</b> Jemperli. Prescribing information. GlaxoSmithKline LLC; 2025. <b>4.</b> Libtayo. Prescribing information. Regeneron Pharmaceuticals, Inc; 2025. <b>5.</b> Loqtorzi. Prescribing information. Coherus BioSciences, Inc; 2025. <b>6.</b> Tevimbra. Prescribing information. BeiGene USA, Inc; 2025. <b>7.</b> Opdualag. Prescribing information. Bristol-Myers Squibb Company; 2024. <b>8.</b> Penpulimab-kcqx. Prescribing information. Akeso Biopharma Co, Ltd; 2025. <b>9.</b> Opdivo Qvantig. Prescribing information. Bristol-Myers Squibb Company; 2025. <b>10.</b> Makker V, Colombo N, Casado A, et al. Lenvatinib plus pembrolizumab in previously treated advanced endometrial cancer: 5-year outcomes from the randomized, phase 3 Study 309/KEYNOTE-775. <em>J Immunother Cancer</em>. 2026;14:e013713. doi:10.1136/jitc-2025-013713 <b>11.</b> Makker V, Colombo N, Casado A, et al. Supplement in: Lenvatinib plus pembrolizumab in previously treated advanced endometrial cancer: 5-year outcomes from the randomized, phase 3 Study 309/KEYNOTE-775. <em>J Immunother Cancer</em>. 2026;14:e013713. doi:10.1136/jitc-2025-013713 <b>12.</b> Data available on request from the Merck National Service Center via email at daprequests@merck.com. Please request US-KLE-01667. <b>13.</b> Makker V, Colombo N, Casado Herráez A, et al. Supplementary appendix to: Lenvatinib plus pembrolizumab for advanced endometrial cancer. <em>N Engl J Med</em>. 2022;386(5):437–448. doi:10.1056/NEJMoa2108330 <b>14.</b> Referenced with permission from the NCCN Clinical Practice Guidelines in Oncology (NCCN Guidelines®) for Uterine Neoplasms V.2.2026. © National Comprehensive Cancer Network, Inc. 2025. All rights reserved. Accessed January 7, 2026. To view the most recent and complete version of the guidelines, go online to NCCN.org. 
                    </Reference>
                </RccReference>
            </Section>
        </EndoLayout>
    )
};

export default Endo;
